import { createSelector } from "reselect";

const currentUser = state => state.rootReducer.currentUserDetails;

export const selectCurrentUser = createSelector([currentUser], currentUser => currentUser);
